import produce from 'immer';
import {
	FETCH_REFUND_STATUS_FAILED,
	FETCH_REFUND_STATUS_FULFILLED,
	FETCH_REFUND_STATUS_PENDING,
} from '../constants/actions/refundsActions';
import IRefundsReducer from '../interfaces/reducers/refundsReducer';

const refundsReducer = produce(
	(draft: IRefundsReducer, action) => {
		switch (action.type) {
			case FETCH_REFUND_STATUS_PENDING: {
				draft.refundLoading = true;
				draft.refundError = false;
				break;
			}
			case FETCH_REFUND_STATUS_FULFILLED: {
				draft.refundLoading = false;
				draft.refund = action.payload;
				draft.refundError = false;
				break;
			}
			case FETCH_REFUND_STATUS_FAILED: {
				draft.refundLoading = false;
				draft.refundError = true;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		refund: null,
		refundsLoading: false,
		refundsError: false,
	}
);

export default refundsReducer;
